import Enum from './enum'

/**
 * 配送方法
 */
class ShippingMethod extends Enum {
    static EMAIL = 1; // メール
    static REGULAR = 2; // 普通便（ゆうパック配送）
    static SPECIAL = 3; // 特別便（宅急便配送）

    static values() {
        return {
            [this.EMAIL]: 'メール',
            [this.REGULAR]: '普通便(ゆうパック配送)',
            [this.SPECIAL]: '特別便(宅急便配送)',
        }
    }
}

export default ShippingMethod;
